import { cn } from "@/utils/cn";
import { memo } from "react";

interface CloseModalIconProps {
  className?: string;
}

export const CloseModalIcon = memo(function CloseModalIcon({ className }: CloseModalIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      className={cn("h-7 w-7", className)}
      aria-hidden
    >
      <path
        d="M22.4941 21.2559C22.5754 21.3372 22.6398 21.4337 22.6838 21.54C22.7278 21.6462 22.7505 21.76 22.7505 21.875C22.7505 21.99 22.7278 22.1038 22.6838 22.21C22.6398 22.3163 22.5754 22.4128 22.4941 22.4941C22.4128 22.5754 22.3163 22.6398 22.21 22.6838C22.1038 22.7278 21.99 22.7505 21.875 22.7505C21.76 22.7505 21.6462 22.7278 21.54 22.6838C21.4337 22.6398 21.3372 22.5754 21.2559 22.4941L14 15.237L6.74406 22.4941C6.57988 22.6582 6.35719 22.7505 6.125 22.7505C5.8928 22.7505 5.67012 22.6582 5.50594 22.4941C5.34175 22.3299 5.24951 22.1072 5.24951 21.875C5.24951 21.6428 5.34175 21.4201 5.50594 21.2559L12.763 14L5.50594 6.74406C5.34175 6.57988 5.24951 6.35719 5.24951 6.125C5.24951 5.8928 5.34175 5.67012 5.50594 5.50594C5.67012 5.34175 5.8928 5.24951 6.125 5.24951C6.35719 5.24951 6.57988 5.34175 6.74406 5.50594L14 12.763L21.2559 5.50594C21.4201 5.34175 21.6428 5.24951 21.875 5.24951C22.1072 5.24951 22.3299 5.34175 22.4941 5.50594C22.6582 5.67012 22.7505 5.8928 22.7505 6.125C22.7505 6.35719 22.6582 6.57988 22.4941 6.74406L15.237 14L22.4941 21.2559Z"
        fill="#663B9E"
      />
    </svg>
  );
});
